export default __webpack_public_path__ + "static/media/questions-xl.03202dee.png";